var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 16.25C14.9999 10.0368 20.0367 5 26.2499 5C32.4632 5 37.4999 10.0368 37.4999 16.25M29.9999 28.3332V16.25C29.9999 14.179 28.3212 12.5 26.2499 12.5C24.1789 12.5 22.5 14.179 22.5 16.25V39.853L17.7073 36.7517C16.1768 35.7615 14.1428 36.1093 13.0282 37.5518C11.997 38.8863 12.062 40.7657 13.1829 42.026L22.5 52.5H42.4999C42.8969 48.9272 43.6082 42.9 44.1709 38.1752C44.6359 34.2702 42.0104 30.6688 38.1502 29.918L29.9999 28.3332Z",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.59fd0cb211b67d07721b47a240e4a158.svg";
export { ForwardRef as ReactComponent };